import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { fromTo } from "utils/misc";
import { TableCell, TableRow } from "@mui/material";
import { useAppointmentLogic } from "components/upcoming-chats/use-appointment-logic";
import useTranslate from "hooks/use-translate-language";
import ClockIcon from "assets/images/clock_gray.png";

const ChatHistoryItem = ({ chats, master_chat_type }) => {
  const translate = useTranslate();
  const {
    speaksSpanish,
    browserTimezone,
    chat_details,
    topic_details,
    startTimeFromCSTToBrowser,
    endTimeFromCSTToBrowser
  } = useAppointmentLogic(chats, master_chat_type);

  // Build comprehensive aria-label for screen readers
  const appointmentDate = moment(chat_details.date_time).format("MMMM DD, yyyy");
  const appointmentTime = `${fromTo(
    startTimeFromCSTToBrowser,
    endTimeFromCSTToBrowser,
    translate("to")
  )} ${moment.tz(browserTimezone).format("z")}`;
  const topicName = !speaksSpanish
    ? topic_details[0]?.topic_name
    : topic_details[0]?.spanish_topic_name ?? topic_details[0]?.topic_name;
  const appointmentType = translate(master_chat_type);
  const providerName = chat_details.dme_details?.name;

  const ariaLabel = `${translate("appointment")}: ${topicName}, ${appointmentType}. ${translate("date")}: ${appointmentDate}, ${appointmentTime}. ${translate("with")}: ${providerName}`;

  return (
    <TableRow
      key={chat_details.slot_id}
      tabIndex={0}
      aria-label={ariaLabel}
    >
      <TableCell aria-labelledby="date-header">
        <div className="upcoming-chat-date-container">
          <img src={ClockIcon} alt="" aria-hidden="true" />
          <div>
            <div style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
              {`${moment(chat_details.date_time).format("MMM")} ${moment(
                chat_details.date_time
              ).format("DD")} ${moment(chat_details.date_time).format("yyyy")}`}
            </div>
            <div className="chat-time">
              {`${fromTo(
                startTimeFromCSTToBrowser,
                endTimeFromCSTToBrowser,
                translate("to")
              )} (${moment.tz(browserTimezone).format("z")})`}
            </div>
          </div>
        </div>
      </TableCell>

      <TableCell aria-labelledby="topic-header">
        <span style={{ fontWeight: "bold" }}>{`${
          !speaksSpanish
            ? topic_details[0]?.topic_name
            : topic_details[0]?.spanish_topic_name ??
              topic_details[0]?.topic_name
        }`}</span>{` | `}
        <span style={{ whiteSpace: "nowrap" }}>
          {`${translate(master_chat_type)}`}
        </span>
      </TableCell>

      <TableCell aria-labelledby="with-header">
        {chat_details.dme_details?.name}
      </TableCell>
      <TableCell aria-hidden="true">
        <span className="sr-only">Spacer</span>
      </TableCell>
      <TableCell aria-hidden="true">
        <span className="sr-only">Spacer</span>
      </TableCell>
    </TableRow>
  );
};

ChatHistoryItem.propTypes = {
  chats: PropTypes.arrayOf(PropTypes.object),
  master_chat_type: PropTypes.string
};

export default ChatHistoryItem;
